<template>
  <div>
    <div id="collCon">
      <div id="aTow">
        <div id="cNav">
          <div>
            <router-link tag="span" :to="{path:'/Collection'}">馆藏</router-link>&nbsp;&nbsp;>>&nbsp;&nbsp;<router-link
              tag="span" :to="{path:'/collection/ceramics',query:{id:id,title:name}}">{{name}}</router-link>&nbsp;&nbsp;>>&nbsp;&nbsp;{{tableData.collectionname}}
          </div>
          <!-- <div v-if="tableData.collectiondynasty===102">
            <router-link tag="span" :to="{path:'/Collection'}">馆藏</router-link>&nbsp;&nbsp;>>&nbsp;&nbsp;<router-link
              tag="span" :to="{path:'/collection/jade'}">青铜器</router-link>&nbsp;&nbsp;>>&nbsp;&nbsp;{{tableData.collectionname}}
          </div>
          <div v-if="tableData.collectiondynasty===103">
            <router-link tag="span" :to="{path:'/Collection'}">馆藏</router-link>&nbsp;&nbsp;>>&nbsp;&nbsp;<router-link
              tag="span" :to="{path:'/collection/copper'}">骨器</router-link>&nbsp;&nbsp;>>&nbsp;&nbsp;{{tableData.collectionname}}
          </div>
          <div v-if="tableData.collectiondynasty===104">
            <router-link tag="span" :to="{path:'/Collection'}">馆藏</router-link>&nbsp;&nbsp;>>&nbsp;&nbsp;<router-link
              tag="span" :to="{path:'/collection/ceramics'}">陶瓷</router-link>&nbsp;&nbsp;>>&nbsp;&nbsp;{{tableData.collectionname}}
          </div>
          <div v-if="tableData.collectiondynasty===105">
            <router-link tag="span" :to="{path:'/Collection'}">馆藏</router-link>&nbsp;&nbsp;>>&nbsp;&nbsp;<router-link
              tag="span" :to="{path:'/collection/painting'}">木质</router-link>&nbsp;&nbsp;>>&nbsp;&nbsp;{{tableData.collectionname}}
          </div>
          <div v-if="tableData.collectiondynasty===106">
            <router-link tag="span" :to="{path:'/Collection'}">馆藏</router-link>&nbsp;&nbsp;>>&nbsp;&nbsp;<router-link
              tag="span" :to="{path:'/collection/clothes'}">石器</router-link>&nbsp;&nbsp;>>&nbsp;&nbsp;{{tableData.collectionname}}
          </div>
          <div v-if="tableData.collectiondynasty===107">
            <router-link tag="span" :to="{path:'/Collection'}">馆藏</router-link>&nbsp;&nbsp;>>&nbsp;&nbsp;<router-link
              tag="span" :to="{path:'/collection/cloth'}">布质</router-link>&nbsp;&nbsp;>>&nbsp;&nbsp;{{tableData.collectionname}}
          </div>
          <div v-if="tableData.collectiondynasty===108">
            <router-link tag="span" :to="{path:'/Collection'}">馆藏</router-link>&nbsp;&nbsp;>>&nbsp;&nbsp;<router-link
              tag="span" :to="{path:'/collection/paper'}">纸质</router-link>&nbsp;&nbsp;>>&nbsp;&nbsp;{{tableData.collectionname}}
          </div> -->
        </div>
        <div style="margin-top: 20px;" id="coll_img">
          <img :src="tableData.collectionimages" style="object-fit: cover;">
        </div>
        <div id="coll_text">
          <div>【{{tableData.collectionname}}】</div>
          <div><span>
              <<
              </span>&nbsp; {{tableData.category}} &nbsp;<span>
              >>
            </span></div>
          <div>{{tableData.collectiondescribe}}</div>
        </div>
        <div style="height: 40px;line-height: 40px;clear: both;margin-top: 20px;margin-bottom: 20px;">
          <div style="float: right;font-size: 1.2em;margin-right: 70px;">分享到：<div style="float: right;">
              <share :config="config"></share>
            </div>
          </div>
        </div>
      </div>
      <div style="clear: both;"></div>
    </div>
    <div id="mcollCon">
      <div id="maTow">
        <div id="mcNav" style="line-height: 50px;">
          <div>
            <router-link tag="span" :to="{path:'/Collection'}">馆藏</router-link>&nbsp;&nbsp;>>&nbsp;&nbsp;<router-link
              tag="span" :to="{path:'/collection/ceramics',query:{id:id,title:name}}">{{name}}</router-link>&nbsp;&nbsp;>>&nbsp;&nbsp;{{tableData.collectionname}}
          </div>
          <!-- <div v-if="tableData.collectiondynasty===102">
            <router-link tag="span" :to="{path:'/Collection'}">馆藏</router-link>&nbsp;&nbsp;>>&nbsp;&nbsp;<router-link
              tag="span" :to="{path:'/collection/jade'}">青铜器</router-link>&nbsp;&nbsp;>>&nbsp;&nbsp;{{tableData.collectionname}}
          </div>
          <div v-if="tableData.collectiondynasty===103">
            <router-link tag="span" :to="{path:'/Collection'}">馆藏</router-link>&nbsp;&nbsp;>>&nbsp;&nbsp;<router-link
              tag="span" :to="{path:'/collection/copper'}">骨器</router-link>&nbsp;&nbsp;>>&nbsp;&nbsp;{{tableData.collectionname}}
          </div>
          <div v-if="tableData.collectiondynasty===104">
            <router-link tag="span" :to="{path:'/Collection'}">馆藏</router-link>&nbsp;&nbsp;>>&nbsp;&nbsp;<router-link
              tag="span" :to="{path:'/collection/ceramics'}">陶瓷</router-link>&nbsp;&nbsp;>>&nbsp;&nbsp;{{tableData.collectionname}}
          </div>
          <div v-if="tableData.collectiondynasty===105">
            <router-link tag="span" :to="{path:'/Collection'}">馆藏</router-link>&nbsp;&nbsp;>>&nbsp;&nbsp;<router-link
              tag="span" :to="{path:'/collection/painting'}">木质</router-link>&nbsp;&nbsp;>>&nbsp;&nbsp;{{tableData.collectionname}}
          </div>
          <div v-if="tableData.collectiondynasty===106">
            <router-link tag="span" :to="{path:'/Collection'}">馆藏</router-link>&nbsp;&nbsp;>>&nbsp;&nbsp;<router-link
              tag="span" :to="{path:'/collection/clothes'}">石器</router-link>&nbsp;&nbsp;>>&nbsp;&nbsp;{{tableData.collectionname}}
          </div>
          <div v-if="tableData.collectiondynasty===107">
            <router-link tag="span" :to="{path:'/Collection'}">馆藏</router-link>&nbsp;&nbsp;>>&nbsp;&nbsp;<router-link
              tag="span" :to="{path:'/collection/cloth'}">布质</router-link>&nbsp;&nbsp;>>&nbsp;&nbsp;{{tableData.collectionname}}
          </div>
          <div v-if="tableData.collectiondynasty===108">
            <router-link tag="span" :to="{path:'/Collection'}">馆藏</router-link>&nbsp;&nbsp;>>&nbsp;&nbsp;<router-link
              tag="span" :to="{path:'/collection/paper'}">纸质</router-link>&nbsp;&nbsp;>>&nbsp;&nbsp;{{tableData.collectionname}}
          </div> -->
        </div>
        <div id="mcoll_img" style="height: 150px;">
          <img :src="tableData.collectionimages">
        </div>
        <div id="mcoll_text">
          <div>【{{tableData.collectionname}}】</div>
          <div><span>
          <<
            </span>&nbsp; {{tableData.category}} &nbsp;<span>
            >>
            </span></div>
          <div>{{tableData.collectiondescribe}}</div>
        </div>
      </div>
      <div style="clear: both;"></div>
      <div style="height: 40px;line-height: 40px;clear: both;margin-top: 20px;margin-bottom: 20px;">
        <div style="float: right;font-size: 1.2em;">分享到：<div style="float: right;">
            <share :config="config"></share>
          </div>
        </div>
      </div>
    </div>
  </div>

</template>

<script>
  import qs from 'qs'
  export default {
    data() {
      return {
        tableData: [],
        loading: false,
        config: {
          url: location.href.split("&t=")[0],
          source: "",
          title: decodeURIComponent(this.$route.query.t),
          description: "",
          image: "",
          weiboKey: "",
          wechatQrcodeTitle: "微信扫一扫：分享",
          wechatQrcodeHelper: "<p>微信里点“发现”，扫一下</p><p>二维码便可将本文分享至朋友圈。</p>",
          wechatQrcodeSize: 100,
          sites: ["weibo", "qq", "wechat"],
          mobileSites: [],
          disabled: [],
          initialized: !1,
          name: '',
          id: 0
        }
      }
    },
    mounted() {
      this.name = this.$route.query.title;
      this.id = this.$route.query.textureid;
      if (this.isMobile()) {
        document.getElementById("mcollCon").style.display = "block";
        document.getElementById("collCon").style.display = "none";
      } else {
        document.getElementById("collCon").style.display = "block";
        document.getElementById("mcollCon").style.display = "none";
      };
      this.handleSearch();
      $("body,html").animate({
        scrollTop: 0
      }, 1);
    },
    methods: {
      isMobile() {
        let flag = navigator.userAgent.match(
          /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
        )
        return flag;
      },
      handleSearch() {
        let eWidth = document.body.clientWidth;
        document.getElementById("collCon").style.width = eWidth + "px";
        document.getElementById("aTow").style.marginLeft = (eWidth - eWidth * 0.9) / 2 + "px";
        document.getElementById("aTow").style.marginRight = (eWidth - eWidth * 0.9) / 2 + "px";
        document.getElementById("coll_img").style.width = eWidth * 0.8 + "px";
        document.getElementById("coll_img").style.height = eWidth * 0.3 + "px";
        document.getElementById("coll_text").style.width = eWidth * 0.8 + "px";
        this.search();
      },
      search: function() {
        let that = this;
        let url = this.HOST + '/api/v1/collection/getOne/' + this.$route.query.collectionid + '';
        this.$axios.get(url).then(function(result) {
          let cData = result.data;
          if (cData && cData.data) {
            that.tableData = cData.data;
            for (let i = 0; i < that.tableData.length; i++) {
              that.picArr.push(that.tableData[i]);
            };
          }
        }).catch(function(error) {
          console.log(err);
        })
      }
    }
  }
</script>

<style scoped>
  #collCon {
    display: none;
  }

  #aTow {
    margin-top: 25px;
    margin-bottom: 25px;
  }

  #coll_img {
    margin: 0 auto;
  }

  #coll_img>img {
    max-width: 100%;
    height: 100%;
  }

  #coll_text {
    text-align: left;
    margin: 0 auto;
    padding-top: 25px;
  }

  #coll_text>div:nth-child(1) {
    font-size: 25px;
    font-weight: 500;
    line-height: 40px;
  }

  #coll_text>div:nth-child(2) {
    font-size: 18px;
    line-height: 30px;
    padding-left: 12px;
    color: #FF0000;
  }

  #coll_text>div:nth-child(3) {
    font-size: 18px;
    line-height: 30px;
    padding-left: 12px;
    text-indent: 35px;
  }

  #collCon>#aTow>#cNav,
  #collCon>#cNav {
    text-align: left;
  }

  #collCon>#aTow>#cNav>div>span:nth-child(1),
  #collCon>#aTow>#cNav>div>span:nth-child(2) {
    cursor: pointer;
  }

  #collCon>#aTow>#cNav>div>span:nth-child(1):hover,
  #collCon>#aTow>#cNav>div>span:nth-child(2):hover {
    color: #FF9900;
  }

  /*mobile*/
  #mcollCon {
    margin: auto 20px;
  }

  #maTow {
    margin-top: 25px;
    margin-bottom: 25px;
  }

  #mcoll_img {
    margin: 0 auto;
  }

  #mcoll_img>img {
    width: 100%;
    height: 100%;
  }

  #mcoll_text {
    text-align: left;
    margin: 0 auto;
    padding-top: 25px;
  }

  #mcoll_text>div:nth-child(1) {
    font-size: 25px;
    font-weight: 500;
    line-height: 40px;
  }

  #mcoll_text>div:nth-child(2) {
    font-size: 18px;
    line-height: 30px;
    padding-left: 12px;
    color: #FF0000;
  }

  #mcoll_text>div:nth-child(3) {
    font-size: 18px;
    line-height: 30px;
    padding-left: 12px;
    text-indent: 35px;
  }

  #mcollCon>#maTow>#mcNav,
  #mcollCon>#mcNav {
    text-align: left;
  }

  #mcollCon>#maTow>#mcNav>div>span:nth-child(1),
  #mcollCon>#maTow>#mcNav>div>span:nth-child(2) {
    cursor: pointer;
  }

  #mcollCon>#maTow>#mcNav>div>span:nth-child(1):hover,
  #mcollCon>#maTow>#mcNav>div>span:nth-child(2):hover {
    color: #FF9900;
  }
</style>



// WEBPACK FOOTER //
// src/pages/collectionDetials/collectionDetials.vue